import { useEffect, useRef, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import LabelInput from "../../../Component/labelInput";
import ToggleButton from "../../../Component/toggleButton";
import DropDown from "../../../Component/dropdown";
import barCode from "../../../Assets/Images/icons/barcode.png";
import { InputField, Submitbtn } from "../../../Component";
import DatePicker from "../../../Component/datePicker";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { getSellingSourceList, returnStock, scanProduct, uploadStockImage } from "../publicationSlice";
import { useDebounce } from "../../../Hooks/useDebounce";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import moment from "moment";
import { hideSnackbar, showSnackbar } from "../../../store/slices/snackbarSlice";
import DateTimePicker from "../../../Component/dateTimePicker";
import DropdownWithClear from "../../..//Component/dropdownWithClear";
const OrderReturn = () => {
    const OrderReturnType = [
        { _id: 1, name: "Order return to", value: "Order return to" },
    ];
    const OrderReturnTo = [
        { _id: 1, name: "Twobrothers Inhouse", value: "twobrothers-inhouse" },
        { _id: 2, name: "Twobrothers Warehouse", value: "twobrothers-warehouse" },
        { _id: 3, name: "Publication Inhouse ", value: "publication-inhouse" },
        { _id: 4, name: "Publication Warehouse", value: "publication-warehouse" },
    ];
    const dispatch: Function = useDispatch<AppDispatch>();
    const [returnType, setReturnType] = useState<any>(OrderReturnType[0]?.value);
    const [returnTo, setReturnTo] = useState<any>(OrderReturnTo[0]?.value);
    const [sellingSourceList, setSellingSourceList] = useState<any>([]);
    const [sellingSource, setSellingSource] = useState<any>();
    const inputRef = useRef<any>(null);
    const [barCodeNumber, setBarCodeNumber] = useState<any>();
    const [productDetails, setProductDetails] = useState<any>([]);
    const [totalAmount, setTotalAmout] = useState<any>();
    const [totalQuantity, setTotalQuantity] = useState<any>(0);
    const [returnDate, setReturnDate] = useState<any>(moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss"));
    const [invoiceNumber, setInvoiceNUmber] = useState<any>();
    const [returnImage, setRetunImage] = useState<any>();
    const [returnImagePrev, setRetunImagePrev] = useState<any>();
    const [returnReason, setReturnReason] = useState<any>("");
    const [isData, setIsData] = useState<boolean>(false)

    useEffect(() => {
        dispatch(getSellingSourceList({
            callback: (res: any) => {
                setSellingSourceList(res?.data);
            },
            errorCallback: (error: any) => { }
        },
        ))
    }, []);
    const handelQRClick = () => {
        inputRef.current.focus();
    };
    const onChangeSellingSource = (value: any) => {
        if (value) {
            setSellingSource(value);
            setTimeout(() => {
                inputRef.current?.focus();
            }, 0);
        }
    };
    const onBarcodeChange = (e: any) => {
        setBarCodeNumber(e.target.value);
    };
    const debouncedProductCode = useDebounce(barCodeNumber, 300);
    useEffect(() => {
        if (debouncedProductCode && debouncedProductCode.length > 12) {
            dispatch(scanProduct({
                id: debouncedProductCode,
                callback: (res: any) => {
                    const sourcePrices = res?.data?.sourcePrice || [];
                    const stockData = res?.data?.stock || [];
                    const matchedSource = sourcePrices.find(
                        (data: any) => data?.sourceName === sellingSource?.name
                    );
                    const findStockData = stockData.find(
                        (stok: any) => stok?.location === returnTo
                    );
                    const findSellingSource = sourcePrices.find(
                        (src: any) => src?.sourceName === sellingSource?.name
                    );
                    if (matchedSource) {
                        const productData = {
                            productId: res?.data?._id,
                            price: findSellingSource?.price,
                            name: res?.data?.name,
                            image: res?.data?.image,
                            uniqueNo: res?.data?.uniqueNo,
                            quantity: findStockData?.quantity,
                            newQuantity: totalQuantity
                        };
                        setProductDetails((prev: any) => [...prev, productData]);
                        setBarCodeNumber('');
                        inputRef?.current?.blur();
                    } else {
                        const productData = {
                            productId: res?.data?._id,
                            price: findSellingSource?.price ?? 0,
                            name: res?.data?.name,
                            image: res?.data?.image,
                            uniqueNo: res?.data?.uniqueNo,
                            quantity: findStockData?.quantity,
                            newQuantity: totalQuantity
                        };
                        setProductDetails((prev: any) => [...prev, productData]);
                        setBarCodeNumber('');
                    };
                },
                errorCallback: (error: any) => {
                    console.error(error);
                },
            }));
        }
    }, [debouncedProductCode]);

    useEffect(() => {
        const productTotalAmout = productDetails
            ?.filter((item: any) => item?.price !== "")
            .reduce((acc: any, curr: any) => {
                return (acc += Number(curr?.price));
            }, 0);
        setTotalAmout(productTotalAmout);
    }, [productDetails]);

    const onChangeNewQuantity = (val: any, item: any, index: number) => {
        const newArr = JSON.parse(JSON.stringify(productDetails));
        // if (val !== "" && val < newArr[index].quantity) {
        // if (val !== "") {
        newArr[index].newQuantity = val;
        calculateTotalQuantity(newArr);
        setProductDetails(newArr);
        // } 
        // else {
        //     newArr[index].newQuantity = "";
        //     setProductDetails(newArr);
        //     dispatch(showSnackbar({ message: "Please enter a valid quantity. It cannot be greater than the existing quantity.", type: "error" }));
        //     setTimeout(() => {
        //         hideSnackbar();
        //     }, 5000);
        // }
        calculateTotalQuantity(newArr);
        setProductDetails(newArr);
    };
    const calculateTotalQuantity = (newArr: any) => {
        const num = newArr
            ?.filter((item: any) => item?._id !== "")
            .reduce((acc: any, curr: any) => {
                return (acc += Number(curr?.newQuantity));
            }, 0);
        setTotalQuantity(num);
    };
    const handleDelete = (index: any) => {
        const newArr = [...productDetails];
        if (index > -1) {
            newArr.splice(index, 1);
        }
        setProductDetails(newArr);
        calculateTotalQuantity(newArr);
    };

    const onChangeUploadReturnImage = (e: any) => {
        e.preventDefault();
        if (!e.target.files?.[0]) return;
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            dispatch(uploadStockImage({
                params: file,
                callback: (res: any) => {
                    if (res) {
                        setRetunImage(res?.data?.name);
                        setRetunImagePrev(reader?.result);
                    }
                },
                errorCallback: () => { },
            }));
        };

        reader.readAsDataURL(file);
    };

    useEffect(() => {
        if (!totalQuantity || !invoiceNumber || !returnImagePrev || !returnDate || !returnReason) {
            setIsData(true);
        } else {
            setIsData(false);
        }
    }, [totalQuantity, invoiceNumber, returnImagePrev, returnDate, returnReason]);

    const handelSubmit = (e: any) => {
        e.preventDefault();
        const products = productDetails.map((item: any) => ({ productId: item.productId, quantity: item.newQuantity }));
        const postData = {
            to: returnTo,
            sourceId: sellingSource?._id,
            status: 4,
            invoiceNo: invoiceNumber,
            file: returnImage,
            remark: returnReason,
            totalCount: totalQuantity,
            totalAmount: totalAmount,
            addedDate: returnDate,
            products: products,
        };
        dispatch(returnStock({
            params: postData,
            callback: (res: any) => {
                if (res?.status === "success") {
                    setReturnType(OrderReturnType[0]?.value);
                    setReturnTo(OrderReturnTo[0]?.value);
                    setSellingSource("");
                    setProductDetails([]);
                    setBarCodeNumber("");
                    setTotalQuantity("");
                    setTotalAmout("");
                    setInvoiceNUmber("");
                    setRetunImage("");
                    setRetunImagePrev("");
                    setReturnReason("");
                    setReturnDate(moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss"));
                    if (inputRef.current) {
                        inputRef.current.value = "";
                    }
                    dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                    setTimeout(() => {
                        hideSnackbar();
                    }, 5000);
                }
            },
            errorCallback(error: any) {
                dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
                setTimeout(() => {
                    hideSnackbar();
                }, 5000);
                console.error(error);
            },
        }))
    };
    const renderTable = () => {
        return (
            <div className="admin-table table-responsive">
                <table className="table table-striped table-hover align-middle text-md-start text-center">
                    <thead>
                        <tr>
                            <th>Product Image</th>
                            <th>Product Name</th>
                            <th>Price</th>
                            <th>Old Quantity</th>
                            <th>New Quantity</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {productDetails?.map((item: any, index: number) => {
                            if (item?.productId) {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <img
                                                src={item?.image}
                                                alt="productImage"
                                                style={{ height: "45px", width: "50px" }}
                                            />
                                        </td>
                                        <td>
                                            {item?.name}
                                        </td>
                                        <td>
                                            <InputField
                                                placeholder=""
                                                setInputText={(value: any) => ('')}
                                                value={item?.price}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                placeholder=""
                                                setInputText={(value: any) => ('')}
                                                value={item?.quantity}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                placeholder=""
                                                setInputText={(value: any) => (onChangeNewQuantity(value, item, index))}
                                                value={item.newQuantity}
                                            // disabled={item.newQuantity > item?.quantity}

                                            />
                                        </td>
                                        <td>
                                            {productDetails?.length != 1 ?
                                                <DeleteForeverIcon className='text-danger cursor' onClick={() => handleDelete(index)} />
                                                : ""
                                            }
                                        </td>
                                    </tr>
                                )
                            }
                        })}

                        <tr className="my-3">
                            <input
                                type="text"
                                className="form-control w-50 my-3"
                                ref={inputRef}
                                value={barCodeNumber}
                                maxLength={13}
                                onChange={onBarcodeChange}
                                disabled={!returnTo || !sellingSource}
                            />
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className="panel-content">
            <div className="mb-4">
                <PageTitle name={"ORDER RETURN"} />
            </div>
            <div className="formDiv">
                <div className="bxshadow p-2 borderRadius mb-4 ">
                    <div className="row mb-3">
                        <div className="col-md-2">
                            <LabelInput labelName={"Return Type"} isRequired />
                            {OrderReturnType.map((option) => (
                                <label key={option._id}>
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="returnType"
                                        value={option.value}
                                        checked={returnType === option.value}
                                        onChange={() => setReturnType(option.value)}
                                    />
                                    <span className="ms-2"></span>{option.name}
                                </label>
                            ))}
                        </div>
                        <div className="col-md-10">
                            <LabelInput labelName={"Order return to"} isRequired />
                            {OrderReturnTo.map((option) => (
                                <label key={option._id} className="me-3">
                                    <input
                                        type="radio"
                                        name="returnTo"
                                        className="form-check-input"
                                        value={option.value}
                                        checked={returnTo === option.value}
                                        onChange={() => setReturnTo(option.value)}
                                    />
                                    <span className="ms-1"> {option.name}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="bxshadow p-2 borderRadius mb-4 ">
                    <div className="row mb-3">
                        <div className="col-md-3 me-md-3">
                            <LabelInput labelName={"Selling Source"} />
                            <DropdownWithClear
                                labelName={"Selling Source "}
                                setInputText={(value: any) => onChangeSellingSource(value)}
                                options={sellingSourceList}
                                value={sellingSource}
                            />
                        </div>
                        <div className="col-md-3">
                            <LabelInput labelName={"Scan QR Code"} />
                            <div className="bxshadow p-2 borderRadius text-center cursor col-3" onClick={handelQRClick}>
                                <img src={barCode} alt="QR Code" width={30} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bxshadow p-2 borderRadius mb-4">
                    {renderTable()}
                </div>
                <div className="bxshadow p-2 borderRadius mb-4">
                    <form onSubmit={handelSubmit}>
                        <div className="row">
                            <div className="col-md-3">
                                <LabelInput labelName={"Total Quantity"} />
                                <InputField
                                    placeholder=""
                                    setInputText={(value: any) => (value)}
                                    value={totalQuantity}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-md-3">
                                <LabelInput labelName={"Selling Date"} />
                                <DateTimePicker
                                    value={returnDate}
                                    setInputText={(value: any) => setReturnDate(value)}
                                />
                            </div>
                            <div className="col-md-3">
                                <LabelInput labelName={"Invoice No"} />
                                <InputField
                                    placeholder="Enter Invoice Number"
                                    setInputText={(value: any) => (setInvoiceNUmber(value))}
                                    value={invoiceNumber}
                                />
                            </div>
                            <div className="col-md-3">
                                <LabelInput labelName={"Return Image"} />
                                <ImagePickerAndViewer
                                    value={returnImagePrev}
                                    handleChange={(e: any) => (onChangeUploadReturnImage(e))}
                                    htmlFor={"photo-upload-1"}
                                    doctype={""} />
                            </div>
                            <div className="col-md-3">
                                <LabelInput labelName={"Return Reason"} />
                                <textarea className="form-control"
                                    rows={3}
                                    name="returnReason"
                                    value={returnReason}
                                    onChange={(e) => setReturnReason(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="my-3 col-md-2 mx-auto">
                            <Submitbtn name="Save and Update Stock" disabled={isData} />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default OrderReturn;
